const microphone = {
  fr: {
    microphonePermissionTitle: 'Autoriser le microphone',
    microphonePermissionHelp: 'Autorisez le microphone pour dicter votre question. Si vous avez refusé l’accès, ouvrez les paramètres de l’application.',
    microphoneOpenSettings: 'Ouvrir les paramètres',
    microphoneUnavailableTitle: 'Message vocal indisponible',
    microphoneUnavailable: 'L’enregistrement vocal n’est pas disponible sur ce téléphone.',
    microphoneTranscriptionFailed: 'La transcription a échoué. Vérifiez votre connexion et réessayez.',
  },
  en: {
    microphonePermissionTitle: 'Allow microphone access',
    microphonePermissionHelp: 'Allow microphone access to dictate your question. If you denied access, open the app settings.',
    microphoneOpenSettings: 'Open settings',
    microphoneUnavailableTitle: 'Voice note unavailable',
    microphoneUnavailable: 'Voice recording is not available on this phone.',
    microphoneTranscriptionFailed: 'Transcription failed. Check your connection and try again.',
  },
  es: {
    microphonePermissionTitle: 'Permitir el micrófono',
    microphonePermissionHelp: 'Permite usar el micrófono para dictar tu pregunta. Si rechazaste el acceso, abre los ajustes de la aplicación.',
    microphoneOpenSettings: 'Abrir ajustes',
    microphoneUnavailableTitle: 'Mensaje de voz no disponible',
    microphoneUnavailable: 'La grabación de voz no está disponible en este teléfono.',
    microphoneTranscriptionFailed: 'No se pudo transcribir. Comprueba la conexión e inténtalo de nuevo.',
  },
  pt: {
    microphonePermissionTitle: 'Permitir o microfone',
    microphonePermissionHelp: 'Permita o uso do microfone para ditar sua pergunta. Se você negou o acesso, abra as configurações do aplicativo.',
    microphoneOpenSettings: 'Abrir configurações',
    microphoneUnavailableTitle: 'Mensagem de voz indisponível',
    microphoneUnavailable: 'A gravação de voz não está disponível neste telefone.',
    microphoneTranscriptionFailed: 'Falha na transcrição. Verifique a conexão e tente novamente.',
  },
  vi: {
    microphonePermissionTitle: 'Cho phép dùng micrô',
    microphonePermissionHelp: 'Cho phép dùng micrô để đọc câu hỏi. Nếu đã từ chối, hãy mở phần cài đặt ứng dụng.',
    microphoneOpenSettings: 'Mở cài đặt',
    microphoneUnavailableTitle: 'Không thể ghi âm',
    microphoneUnavailable: 'Điện thoại này không hỗ trợ ghi âm trong ứng dụng.',
    microphoneTranscriptionFailed: 'Không thể chuyển giọng nói thành văn bản. Kiểm tra kết nối rồi thử lại.',
  },
  hi: {
    microphonePermissionTitle: 'माइक्रोफ़ोन की अनुमति दें',
    microphonePermissionHelp: 'सवाल बोलकर लिखने के लिए माइक्रोफ़ोन की अनुमति दें। अनुमति न दी हो तो ऐप सेटिंग खोलें।',
    microphoneOpenSettings: 'सेटिंग खोलें',
    microphoneUnavailableTitle: 'वॉइस नोट उपलब्ध नहीं है',
    microphoneUnavailable: 'इस फ़ोन पर वॉइस रिकॉर्डिंग उपलब्ध नहीं है।',
    microphoneTranscriptionFailed: 'बोली को लिखने में समस्या हुई। कनेक्शन जाँचें और फिर कोशिश करें।',
  },
  ar: {
    microphonePermissionTitle: 'السماح باستخدام الميكروفون',
    microphonePermissionHelp: 'اسمح باستخدام الميكروفون لإملاء سؤالك. إذا رفضت الإذن، افتح إعدادات التطبيق.',
    microphoneOpenSettings: 'فتح الإعدادات',
    microphoneUnavailableTitle: 'الرسالة الصوتية غير متاحة',
    microphoneUnavailable: 'التسجيل الصوتي غير متاح على هذا الهاتف.',
    microphoneTranscriptionFailed: 'فشل تحويل الصوت إلى نص. تحقق من الاتصال وحاول مرة أخرى.',
  },
  ur: {
    microphonePermissionTitle: 'مائیکروفون کی اجازت دیں',
    microphonePermissionHelp: 'سوال بول کر لکھنے کے لیے مائیکروفون کی اجازت دیں۔ اگر اجازت مسترد کی ہے تو ایپ کی ترتیبات کھولیں۔',
    microphoneOpenSettings: 'ترتیبات کھولیں',
    microphoneUnavailableTitle: 'وائس نوٹ دستیاب نہیں',
    microphoneUnavailable: 'اس فون پر آواز ریکارڈ کرنے کی سہولت دستیاب نہیں ہے۔',
    microphoneTranscriptionFailed: 'آواز کو متن میں بدلنا ناکام ہوا۔ کنکشن چیک کریں اور دوبارہ کوشش کریں۔',
  },
};

export default microphone;
